import React from "react";
import Representation from "./Representation";

const ServiceUnavailable = (props) => <Representation {...props} />;

export default ServiceUnavailable;
